import { Box } from "@mui/material"
import { ImgWrapper } from "components/ImgContainer/ImgWrapper"
import { useBreak } from "hooks/useBreak"
import React from "react"
import { getFocus, useGet } from "state/jotai"
import { active_project } from "state/store.global"
import { _project } from "state/store.projects"

export const AllImagePack = ({ allImages, setActiveGlry, activeGlry }) => {
    const isDesktop = useBreak("md_up");
    const { pin, pid } = useGet(active_project);
    const buttonsLabel = getFocus(_project, "buttonsLabel")?.[pin]?.[pid] ?? [];

    let totalImgCount = 0;
    const imageElements = [];

    allImages.forEach((image, index) => {
        if (!index) return; // skip first
        const keys = Object.keys(image ?? {});
        const i_keys = keys.length && Object.keys(image[keys[0]] ?? {});

        Boolean(i_keys.length) &&
            i_keys.forEach((i_k) => {
                const img_url = image[keys[0]]?.[i_k]?.Data?.ListOfPhotos?.find(
                    (au) => au.Description === "Forsidebillede"
                );
                if (img_url && totalImgCount < 4) {
                    totalImgCount++;
                    imageElements.push(
                        <ImgWrapper
                            key={`${index}${i_k}`}
                            img={img_url?.Url}
                            alt="gallary images"
                            style={{
                                width: "100%",
                                height: "100%",
                                borderRadius: "6px",
                                objectFit: "cover",
                                overflow: "hidden",
                            }}
                        />
                    );
                } else if (img_url) {
                    totalImgCount++;
                }
            });
    });

    // Determine grid layout dynamically
    const gridTemplate =
        totalImgCount === 1
            ? { gridTemplateColumns: "1fr", gridTemplateRows: "1fr" }
            : { gridTemplateColumns: "repeat(2, 1fr)", gridTemplateRows: "repeat(2, 1fr)" };

    return (
        <div>
            <Box
                onClick={() => setActiveGlry({})}
                sx={{
                    display: "flex",
                    flexDirection: "column",
                    cursor: "pointer",
                    width: isDesktop ? "300px" : "200px",
                    height: "100%",
                    padding: "0 8px",
                    transition: "transform 0.3s linear",
                    overflow: "hidden",
                    "&:hover": {
                        transform: "scale(calc(308/300))",
                    },
                }}
            >
                <Box
                    sx={{
                        position: "relative",
                        display: "grid",
                        gap: "8px",
                        width: "100%",
                        height: "100%",
                        ...gridTemplate,
                    }}
                >
                    {imageElements}

                    {/* Overlay for remaining images */}
                    {totalImgCount > 4 && (
                        <Box
                            sx={{
                                position: "absolute",
                                inset: 0,
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                backgroundColor: "rgba(0,0,0,0.55)",
                                borderRadius: "6px",
                                color: "#fff",
                                fontWeight: "bold",
                                fontSize: "1.2rem",
                            }}
                        >
                            +{totalImgCount - 4}
                        </Box>
                    )}
                </Box>

                {/* keep your label untouched */}
                <p
                    className={
                        Object.keys(activeGlry || {}).length
                            ? "paragraph1-light"
                            : "h4-medium"
                    }
                    style={{ marginTop: "8px" }}
                >
                    {
                        buttonsLabel?.filter(
                            (btn) => btn.UILabelProperty === "AlleEjendomme"
                        )[0]?.Label
                    }
                </p>
            </Box>
        </div>
    );
};
